import { useEffect } from "react";

export default function SEO({
  title = "Imalandia | Imanes personalizados con fotos",
  description = "Crea imanes personalizados, collages magnéticos, marcos y accesorios decorativos a partir de tus fotos favoritas.",
  canonical,
  noindex = false,
  image = "/images/branding/logo_imalandia.png",
  imageAlt = "Imalandia",
}) {
  useEffect(() => {
    const origin =
      canonical ||
      (typeof window !== "undefined" ? window.location.origin : "");
    const absoluteImage = image?.startsWith("http")
      ? image
      : new URL(image, origin).href;

    const setMeta = (selector, match, values) => {
      let tag = document.querySelector(selector);

      if (!tag) {
        tag = document.createElement("meta");
        Object.entries(match).forEach(([name, value]) => {
          tag.setAttribute(name, value);
        });
        document.head.appendChild(tag);
      }

      Object.entries(values).forEach(([name, value]) => {
        tag.setAttribute(name, value);
      });
    };

    document.title = title;

    setMeta(
      'meta[name="description"]',
      { name: "description" },
      { name: "description", content: description },
    );

    setMeta(
      'meta[name="robots"]',
      { name: "robots" },
      {
        name: "robots",
        content: noindex ? "noindex, nofollow" : "index, follow",
      },
    );

    setMeta(
      'meta[property="og:title"]',
      { property: "og:title" },
      { property: "og:title", content: title },
    );

    setMeta(
      'meta[property="og:description"]',
      { property: "og:description" },
      { property: "og:description", content: description },
    );

    setMeta(
      'meta[property="og:type"]',
      { property: "og:type" },
      { property: "og:type", content: "website" },
    );

    setMeta(
      'meta[property="og:image"]',
      { property: "og:image" },
      { property: "og:image", content: absoluteImage },
    );

    setMeta(
      'meta[property="og:image:alt"]',
      { property: "og:image:alt" },
      { property: "og:image:alt", content: imageAlt },
    );

    setMeta(
      'meta[name="twitter:card"]',
      { name: "twitter:card" },
      { name: "twitter:card", content: "summary_large_image" },
    );

    setMeta(
      'meta[name="twitter:title"]',
      { name: "twitter:title" },
      { name: "twitter:title", content: title },
    );

    setMeta(
      'meta[name="twitter:description"]',
      { name: "twitter:description" },
      { name: "twitter:description", content: description },
    );

    if (canonical) {
      let canonicalTag = document.querySelector('link[rel="canonical"]');

      if (!canonicalTag) {
        canonicalTag = document.createElement("link");
        canonicalTag.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalTag);
      }

      canonicalTag.setAttribute("href", canonical);

      setMeta(
        'meta[property="og:url"]',
        { property: "og:url" },
        { property: "og:url", content: canonical },
      );
    }
    setMeta(
      'meta[name="twitter:image"]',
      { name: "twitter:image" },
      { name: "twitter:image", content: absoluteImage },
    );
  }, [title, description, canonical, noindex, image, imageAlt]);

  return null;
}
